/**
 * Functions for special GTM Ecommerce events to generate custom payloads via code
 */

import datalayerPush from './data-layer'
import { EventContext } from './segment-tracking'

function productImpression(ctx: EventContext) {
  const data = ctx.processedPayload
  eCommGTM({
    currencyCode: 'GBP',
    impressions: data.products,
  })
}

function addToBasket(ctx: EventContext) {
  const data = ctx.processedPayload
  eCommGTM({
    currencyCode: 'GBP',
    add: {
      actionField: {
        list: data.list,
      },
      // Our data is not in an array since this is a single product event, so
      products: [data],
    },
  })
}

function productDetails(ctx: EventContext) {
  const data = ctx.processedPayload
  eCommGTM({
    detail: {
      actionField: {
        list: data.list,
      },
      products: [data],
    },
  })
}

function productClicked(ctx: EventContext) {
  const data = ctx.processedPayload
  eCommGTM({
    click: {
      actionField: {
        list: data.list,
      },
      products: [data],
    },
  })
}

type EcommFunction = (ctx: EventContext) => void
interface EcommFunctions {
  [key: string]: EcommFunction
}

export const ecommFunctions: EcommFunctions = {
  'Product Impression GTM': productImpression,
  'Product Viewed GTM': productDetails,
  'Product Added GTM': addToBasket,
  'Product Clicked GTM': productClicked,
}

function eCommGTM(payload: any) {
  // Clear the previous Ecommerce event
  datalayerPush({ ecommerce: null })
  const finalPayload = { event: 'eCommEvent', ecommerce: payload }
  // console.log(`Sending GTM Ecomm event`, finalPayload)
  datalayerPush(finalPayload)
}
